import styled from 'styled-components'
import { Modal as AntDModal } from 'antd'

export const Modal = styled(AntDModal)`
  padding: 0px;
  box-shadow: none;
  border-radius: 10px;
  overflow: hidden;
  background-color: white;

  .ant-modal-content {
    padding: 32px;

    .ant-modal-header {
      border: 0px;
      padding: 0px;
      margin-bottom: 32px;
    }

    .ant-modal-title {
      padding: 0px;
      font-size: 32px;
      font-weight: 500;
      line-height: normal;
    }

    .ant-modal-body {
      border: 0px;
      padding: 0px;
    }

    .ant-modal-footer {
      border: 0px;
      padding: 0px;
    }
  }
`
